<h1 mat-dialog-title>{{ data.header }}</h1>
<div mat-dialog-content [innerHTML]="data.text"></div>
<div mat-dialog-content style="color:#555; font-size:14px" [innerHTML]="data.info"></div>
<div mat-dialog-content [innerHTML]="data.question"></div>
<br />
<div class="button-row" fxLayout="row" fxLayoutAlign="end" fxLayoutGap="2.5%">
	<button mat-raised-button (click)="confirm()" color="primary" >{{ data.ok_label }}</button>
	<button mat-raised-button (click)="cancel()" cdkFocusInitial>{{ data.cancel_label }}</button>
</div>
